// src/lib/docs.js
import { supabase } from 'services/supabaseClient';

/**
 * Generate a signed URL for a document and open it in a new tab.
 * @param {string} filePath
 */
export async function openDoc(filePath) {
  if (!filePath) return;

  const { data, error } = await supabase.storage
    .from('record_docs_files')   // bucket name used for doc storage
    .createSignedUrl(filePath, 60);

  if (error) {
    console.error('❌ Error creating signed URL:', error);
    return;
  }

  window.open(data.signedUrl, '_blank');
}
